export const DEFAULT_COLORS = ['#648de6', '#bba8f6', '#2edcea', '#c06868', '#fc9a61', '#fddc4a', '#acd942', '#68bea8', '#eea4da', '#a1c2ff'];